// extracted by mini-css-extract-plugin
module.exports = {"li":"header-module--li--2n0PE","navList":"header-module--nav-list--87D9u","title":"header-module--title--33kOg"};